import { getSellOrderDetailApi, sellDeliverOrderDeleteApi } from "./services";
import { VRow, VCol } from "vuetify/lib";
import DelModel from "./DelModel";
import VTable from "@/vuetify_custom/v-table/v3";
import VModel from "@/vuetify_custom/v-modal_v1";
import { VBtn, VMenu, VList, VListItem, VListItemTitle } from "vuetify/lib";
import UserFlowBase from "@/views/components/flow/user_flow_base_jsx_v1";
import DeliverOrderDetailModal from "./DeliverOrderDetailModal";
import { ResellShopWarehouseHash } from "./constants";
import { getDeliveryWarehouseName } from "@/libs/delivery_warehouse";

import {
  DeliveryNoticeStatusMap,
  DeliveryNoticeSettlementStatusMap,
} from "./constants";
import styles from "./style.module.less";

export default {
  props: {},
  data() {
    return {
      loading: false,
      error: false,
      detail: {},
      dis: false,
      id: null,
    };
  },
  computed: {
    // 订单sku列表
    skuListHeader() {
      return [
        {
          text: "sku代码",
          align: "center",
          value: "stock_code",
          width: 150,
        },
        {
          text: "sku名称",
          align: "center",
          value: "stock_name",
          width: 150,
        },
        {
          text: "销售类型",
          align: "center",
          value: "sell_type",
          width: 150,
          render: (_, __) => {
            return <div>{__?.sell_type === 1 ? "销售" : "赠品"}</div>;
          },
        },
        {
          text: "单价",
          align: "center",
          value: "price",
          width: 150,
        },
        {
          text: "数量",
          align: "center",
          value: "quantity",
          width: 150,
        },
        {
          text: "金额",
          align: "center",
          value: "amount",
          width: 150,
        },
        {
          text: "已发数量",
          align: "center",
          value: "delivered_quantity",
          width: 150,
        },
        {
          text: "待发数量",
          align: "center",
          value: "wait_deliver_num",
          width: 150,
          render: (_, __) => {
            if (__?.quantity === __?.delivered_quantity) {
              return <div>0</div>;
            }
            const rest = __?.quantity - __?.delivered_quantity;
            return <div>{rest}</div>;
          },
        },
        {
          text: "结算单号",
          align: "center",
          value: "settlement_order_code",
          width: 150,
        },
        {
          text: "已收款金额",
          align: "center",
          value: "receipt_amount",
          width: 150,
        },
      ];
    },
    // 发货通知列表
    deliveryNoticeHeader() {
      return [
        {
          text: "发货通知号",
          align: "center",
          value: "uid",
          width: 150,
        },
        {
          text: "渠道",
          align: "center",
          value: "channel",
          width: 150,
          render: (_, __) => {
            return <div>{this.detail?.payee_company_name || "-"}</div>;
          },
        },
        {
          text: "地址",
          align: "center",
          value: "address",
          width: 150,
          render: (_, __) => {
            return (
              <div>
                <div>{__?.province}</div>
                <div>{__?.city}</div>
                <div>{__?.area}</div>
                <div>{__?.recv_detail_address}</div>
              </div>
            );
          },
        },
        {
          text: "收货人",
          align: "center",
          value: "recv_user",
          width: 150,
        },
        {
          text: "订单编号",
          align: "center",
          value: "order_code",
          width: 150,
          render: () => {
            return <div>{this.detail?.uid || "-"}</div>;
          },
        },
        {
          text: "备注",
          align: "center",
          value: "memo",
          width: 150,
        },
        {
          text: "状态",
          align: "center",
          value: "action",
          width: 150,
          render: (_, __) => {
            return <div>{DeliveryNoticeStatusMap[__?.status] || "-"}</div>;
          },
        },
        {
          text: "结算状态",
          align: "center",
          value: "settlement_status",
          width: 150,
          render: (_, __) => {
            return (
              <div>
                {DeliveryNoticeSettlementStatusMap[__?.settlement_status] ||
                  "-"}
              </div>
            );
          },
        },
        {
          text: "流程",
          align: "center",
          value: "user_flow",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            return (
              <div>
                <UserFlowBase
                  modelC={row.user_flow}
                  user_flow={row.user_flow}
                  show_handles={true}
                  on={{
                    ["on-change"]: () => {
                      console.log("on-change");
                      this.refresh();
                    },
                  }}
                />
              </div>
            );
          },
        },
        {
          text: "操作",
          align: "center",
          value: "action",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            const canEdit =
              row.user_flow.current_user_flow_node.flow_node_name ===
              "业务申请";
            return (
              <div>
                <VMenu
                  offset-y
                  close-on-click={true}
                  scopedSlots={{
                    activator: ({ on, attrs }) => (
                      <VBtn
                        {...attrs}
                        on={on}
                        color="primary"
                        small
                        style="margin: 10px 0;"
                      >
                        操作
                      </VBtn>
                    ),
                  }}
                >
                  <VList>
                    <VListItem
                      key="detail"
                      on={{
                        click: () => {
                          this.$refs.deliverOrderDetailModal.open(
                            row.sell_order_id,
                            row.id
                          );
                        },
                      }}
                    >
                      <VListItemTitle>详情</VListItemTitle>
                    </VListItem>
                    {canEdit && (
                      <VListItem
                        key="edit"
                        on={{
                          click: () => {
                            this.$emit("edit", row);
                          },
                        }}
                      >
                        <VListItemTitle>编辑</VListItemTitle>
                      </VListItem>
                    )}
                    <VListItem
                      key="delete"
                      on={{
                        click: () => {
                          this.$refs.delModel.open(row.id);
                        },
                      }}
                    >
                      <VListItemTitle>废弃</VListItemTitle>
                    </VListItem>
                  </VList>
                </VMenu>
              </div>
            );
          },
        },
      ];
    },
  },
  mounted() {},
  methods: {
    close() {
      this.dis = false;
    },
    open(id) {
      this.id = id;
      this.dis = true;
      this.loading = true;
      getSellOrderDetailApi({
        id: id,
      })
        .then((res) => {
          this.loading = false;
          this.detail = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.open(this.id);
    },
  },
  render() {
    const resellShopWarehouse = ResellShopWarehouseHash[this.detail.shop_id] || {};
    return (
      <VModel
        fullscreen
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={"详情"}
        loading={this.loading}
        on={{
          ok: this.close,
          cancel: this.close,
        }}
      >
        <div class={styles.orderDetail}>
          <div style="margin-bottom: 16px;">
            <div>
              <strong>发货店铺：</strong>
              {resellShopWarehouse.shop_name || "-"}
            </div>
            <div>
              <strong>发货仓：</strong>
              {getDeliveryWarehouseName(this.detail.warehouse_code)}
            </div>
          </div>
          <VRow>
            <VCol span={12}>
              <h2>sku信息</h2>
              <VTable
                desserts={this.detail.sell_order_items}
                headers={this.skuListHeader}
              />
            </VCol>
            <VCol span={12}>
              <h2>发货通知单</h2>
              <VTable
                headers={this.deliveryNoticeHeader}
                desserts={this.detail.sell_deliver_orders}
              />
            </VCol>
          </VRow>
        </div>
        <DelModel
          ref="delModel"
          on-success={this.refresh}
          delApi={sellDeliverOrderDeleteApi}
        />
        <DeliverOrderDetailModal ref="deliverOrderDetailModal" />
      </VModel>
    );
  },
};
